import { useCallback } from 'react';
import { difference, orderBy } from 'lodash';
import { TAGS_QUERY } from 'src/graphql/tag/query';
import client from 'src/utils/api/client';
import useGetMobilePhotoRecordData from './useGetMobilePhotoRecordData';

export default (jobId, tagsConfiguration) => {
  const { execute: getPhotoRecordsFromDB } = useGetMobilePhotoRecordData(jobId);

  return useCallback(async () => {
    const photoRecords = await getPhotoRecordsFromDB();

    const linkedTagIds = (photoRecords || [])
      .map(({ tags }) => tags.map(tag => tag.tagId))
      .flat();

    const requiredTags = tagsConfiguration?.currentVersion?.tagsConfigurationTags || [];

    if (requiredTags.length === 0) {
      return [[], false];
    }

    const requiredEssentialTagIds = requiredTags.filter(c => c.requirement === 'essential').map(c => c.tagId);

    const diff = difference(requiredEssentialTagIds, linkedTagIds);
    if (diff.length > 0) {
      const { data } = await client.query({
        query: TAGS_QUERY,
        variables: { limit: 1000, offset: 0, q: '', withDeleted: false },
      });

      const missingTags = orderBy((data?.tags || [])
        .filter(tag => diff.includes(tag.id))
        .map(tag => tag.currentVersion || {}),
      [tag => tag.name], ['asc']);

      if (missingTags && missingTags.length > 0) {
        return [missingTags, true];
      }

      return [[], false];
    }

    return [[], false];
  }, [jobId, JSON.stringify(tagsConfiguration)]);

};
